<template>
  <div class="secNav">
    <ul>
      <li v-for="(item, index) in menu" @click="emitEvent(item.name, item.router, index)"
          :class="{active: index === currentIndex}">{{$t('secNav.'+item.name)}}
      </li>
    </ul>
  </div>
</template>

<!--
  使用方法: 传递menu菜单数组
           并定义menuClick方法,参数为菜单项名称
-->

<script>

  import {ref} from 'vue'
  import bus from 'vue3-eventbus'  //引入事件总线

  export default {
    name: "SecNav",
    props: {
      menu: {
        type: Array,
        default: [],
      }
    },
    emits: ['menuClick'],
    setup(props, context) {

      let currentIndex = ref(0);

      function emitEvent(menuName, addr, index) {
        currentIndex.value = index;
        context.emit('menuClick', menuName, addr)
        //console.log('menu',props.menu[0].name)
      }

      return {
        currentIndex,
        emitEvent
      }
    }
  }
</script>

<style scoped lang="less">
  .secNav {
    display: flex;
    justify-content: center;

    ul, li {
      list-style: none;
      height: 60px;
      float: left;

    }

    ul {
      background-color: rgb(233, 245, 238);
      border-radius: 30px;
      padding: 0 20px;
      cursor: pointer;

      li {
        float: left;
        display: block;
        text-align: center;
        font-size: 16px;
        width: 230px;
        line-height: 60px;
        color: #24a056;
        background: url("~assets/img/secNav/background.jpg") no-repeat right;
      }

      li:last-child {
        background-image: none;
      }

      .active {
        background: #24a056;
        color: white;
        border-radius: 30px;
      }

      li:hover {
        background: #24a056;
        border-radius: 30px;
        color: #ffffff;
      }
    }
  }

</style>